/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TeamCheckInfoResponse { 
    video_id: string;
    team_check_completed: boolean;
    video_title: string;
    detection_image_url?: string | null;
}

